"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionAutoExtend = void 0;
var react_1 = require("react");
var interval = 25 * 60 * 1000; // 25 minutes
var callCountLimit = 20;
var useSessionAutoExtend = function (refreshSession) {
    var createTimer = function () {
        var count = 0;
        var thisInterval = setInterval(function () {
            count++;
            refreshSession();
            if (count >= callCountLimit) {
                clearInterval(thisInterval);
            }
        }, interval);
        return thisInterval;
    };
    react_1.useEffect(function () {
        var newTimer = createTimer();
        return function () {
            clearInterval(newTimer);
        };
    }, []);
};
exports.useSessionAutoExtend = useSessionAutoExtend;
//# sourceMappingURL=UseSessionAutoExtend.js.map